import React from "react";
import { ComponentExt } from "@src/utils/reactExt";
import * as styles from "./styles/index.scss"
import new_giftBg from "@assets/img/newgiftbg.jpg"
import { InputItem, Button } from 'antd-mobile'
import { createForm } from 'rc-form';
import { isValidPhone } from "@utils/index"
class Gift extends ComponentExt<any, any>{
    constructor(props) {
        super(props)
        this.state = {
            info: '',
            color: '',
        }
    }
    doSubmit = () => {
        this.props.form.validateFields(async (error, value) => {
            if (!error) {
                if (!isValidPhone(value.phone)) {
                    return this.setState({ info: '请输入正确的手机号', color: '' })
                }
                try {
                    this.$toast.loading('领取中，请稍后')
                    await this.api.receiveSubScribeGift({ phone: value.phone })
                    this.setState({ info: '流量兑换券已下发到账户,请注意查收 ', color: '#78533b' })
                    this.$toast.hide()
                } catch (error) {
                }
            }
        })
    };
    render(): React.ReactNode {
        const { getFieldProps } = this.props.form;
        return (
            <div className={styles.giftWrapper} style={{ backgroundImage: `url(${new_giftBg})` }}>
                <div className={styles.content}>
                    <h2>新人专享</h2>
                    <InputItem
                        {...getFieldProps('phone',)}
                        placeholder={'请正确输入手机号'}
                        className={styles.inputItem}
                    />
                    <p className={styles.giftInfo} style={{ color: this.state.color || 'red' }}>{this.state.info}</p>
                    <Button className={styles.btn} onClick={this.doSubmit}>立即领取</Button>
                    <div className={styles.footTotal}>
                        <span>说明:</span>
                        <span>该活动只针对未关注过本公众号的用户，老用户可领取不定期推送的优惠福利。</span>
                    </div>
                    <div className={styles.footTotal}>
                        <span>规则:</span>
                        {/* <span>已激活用户立即下发，未激活用户激活后立即下发流量。</span> */}
                        <span>领取成功后发放到个人账户，可进入【懂的智能互联】小程序-我的-优惠卡券中查看。</span>
                    </div>
                </div>
            </div>
        )
    }
}
export default createForm()(Gift)